const ACCORDION_SELECTOR = '.js-accordion';
const ACCORDION_TRIGGER_SELECTOR = '.js-accordion-trigger';
const BUTTON_CLASS = 'accordion-panel__button';
const ACTIVE_CLASS = 'is-active';
const ANIMATION_DURATION = 300;

const createAccordionButton = (trigger: HTMLElement, buttonId: string, contentId: string): HTMLButtonElement => {
  const button = document.createElement('button');
  button.type = 'button';
  button.id = buttonId;
  button.className = BUTTON_CLASS;
  button.setAttribute('aria-expanded', 'false');
  button.setAttribute('aria-controls', contentId);
  button.innerHTML = trigger.innerHTML;
  return button;
};

const setupAccordionContent = (content: HTMLElement, contentId: string, buttonId: string): void => {
  content.id = contentId;
  content.setAttribute('aria-labelledby', buttonId);
  content.setAttribute('aria-hidden', 'true');
};

const toggleAccordionContent = (content: HTMLElement, isExpanded: boolean): void => {
  content.setAttribute('aria-hidden', (!isExpanded).toString());
  
  if (isExpanded) {
    content.style.display = 'block';
    content.style.height = '0';
    content.style.overflow = 'hidden';
    content.style.transition = `height ${ANIMATION_DURATION}ms ease-out`;
    content.offsetHeight;
    content.style.height = `${content.scrollHeight}px`;
    
    setTimeout(() => {
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
    }, ANIMATION_DURATION);
  } else {
    content.style.height = `${content.scrollHeight}px`;
    content.style.overflow = 'hidden';
    content.style.transition = `height ${ANIMATION_DURATION}ms ease-in`;
    content.offsetHeight;
    content.style.height = '0';
    
    setTimeout(() => {
      content.style.display = 'none';
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
    }, ANIMATION_DURATION);
  }
};

const handleAccordionClick = (button: HTMLButtonElement, content: HTMLElement): void => {
  const isCurrentlyExpanded = button.getAttribute('aria-expanded') === 'true';
  const newState = !isCurrentlyExpanded;

  button.setAttribute('aria-expanded', newState.toString());
  button.classList.toggle(ACTIVE_CLASS, newState);
  
  toggleAccordionContent(content, newState);
};

const initializeAccordionItem = (trigger: HTMLElement, index: number): void => {
  if (trigger.querySelector(`.${BUTTON_CLASS}`)) {
    return;
  }

  const content = trigger.nextElementSibling as HTMLElement;
  if (!content) {
    console.warn('Accordion content not found for trigger:', trigger);
    return;
  }

  const buttonId = `heading-${index}`;
  const contentId = `accordion-${index}`;
  const button = createAccordionButton(trigger, buttonId, contentId);
  trigger.innerHTML = '';
  trigger.appendChild(button);

  setupAccordionContent(content, contentId, buttonId);

  button.addEventListener('click', () => {
    handleAccordionClick(button, content);
  });
};

const openFirstAccordionItems = (): void => {
  const accordionGroups = document.querySelectorAll(ACCORDION_SELECTOR);
  
  accordionGroups.forEach((group) => {
    const firstTrigger = group.querySelector(ACCORDION_TRIGGER_SELECTOR);
    if (firstTrigger) {
      const firstButton = firstTrigger.querySelector(`.${BUTTON_CLASS}`) as HTMLButtonElement;
      if (firstButton) {
        firstButton.click();
      }
    }
  });
};

const init = (): void => {
  const accordionTriggers = document.querySelectorAll<HTMLElement>(ACCORDION_TRIGGER_SELECTOR);
  
  accordionTriggers.forEach((trigger, index) => {
    initializeAccordionItem(trigger, index);
  });

  openFirstAccordionItems();
};

export { init, handleAccordionClick };
